module.exports = __webpack_public_path__ + "img/avatar.ba171c60.png";